import { FC } from 'react';
import { FormikProps } from 'formik';
import FormGroup from '@material-ui/core/FormGroup';
import { PrimaryReadOnlyField, UISubmit, UIReturn, UIError } from '../index';
import useStyles from '../../assets/styles/Master.css';
import { AUTH_TYPE } from '../../constants/authority';
import _ from 'lodash';
import useUikitStyles from '../../assets/styles/Uikit.css';
/**
 *
 *
 *
 * @method Interface
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
interface FormValues {
  name: string;
  authorityId: string;
  authType: string;
}

/**
 *
 *
 *
 * @method Components
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
const OrganizationConfirm: FC<FormikProps<FormValues>> = (props) => {
  const { handleSubmit, values, errors } = props;
  const classes = useStyles();
  const authType = _.find(AUTH_TYPE, { value: values.authType });
  const uikitClasses = useUikitStyles();

  return (
    <form onSubmit={handleSubmit} noValidate autoComplete="off">
      <p className={classes.errorMessage}>
        <UIError errors={errors} />
      </p>
      <div className={uikitClasses.root}>
        <PrimaryReadOnlyField label="ユーザー名" value={values.name} />
        <PrimaryReadOnlyField
          label="権限"
          value={authType ? authType.name : ''}
        />
      </div>

      <div className="module-spacer--medium" />

      <FormGroup row>
        <UIReturn title="戻る" />
        <div className="module-spacer--button" />
        <UISubmit title="確定" />
      </FormGroup>
    </form>
  );
};

export default OrganizationConfirm;
